module.exports = __webpack_public_path__ + "static/media/GaryAAvatar.fe4107e2.png";